// Framework and third-party non-ui
import * as React from 'react';
import LayerListVM from '@arcgis/core/widgets/LayerList/LayerListViewModel';

// Hooks, context, and constants

// App components
import { LayerCard } from './LayerCard';

// JSON & Styles
import { SidebarHeader, SidebarSection } from './Sidebar-styled';

// Third-party components (buttons, icons, etc.)

export const LayerListContainer = ({ mapView }) => {
  if (!mapView) return 'loading';

  const { LayerCollection } = window.Pin2Flood;

  const [layerList, setLayerList] = React.useState(null);
  const [layers, setLayers] = React.useState([]);
  const [basemap, setBasemap] = React.useState(null);

  const toggleLayer = (layer) => {
    const item = layerList.operationalItems.items
      .map((item) => {
        if (item.layer.type === 'group') return item.children.items;
        return item;
      })
      .flat()
      .find((l) => l.title === layer.name);

    item.layer.visible = !layer.selected;

    setLayers([
      ...layers.filter((l) => l.name !== layer.name),
      { ...layer, selected: !layer.selected },
    ]);
  };

  const getLayers = (layerCollection, layerList) => {
    const items = layerList.operationalItems.items
      .map((item) => {
        if (item.layer.type === 'group') return item.children.items;
        return item;
      })
      .flat();

    return layerCollection
      .map((layer, i) => {
        const { name, label, overlay } = layer;
        const thumbnailUrl = basemap?.thumbnailUrl
          ? basemap.thumbnailUrl
          : window.mapGallery?.items?.items[0]?.basemap?.thumbnailUrl;

        try {
          const lyr = items.find((item) => item.title === name);
          const visible = lyr?.visible;

          if (lyr.error !== null) {
            return null;
          }

          return {
            id: i,
            name,
            label,
            thumbnailUrl,
            thumbnailOverlay: overlay,
            selected: visible,
          };
        } catch (error) {
          console.error(error);
          return null;
        }
      })
      .filter((l) => l !== null);;
  };

  React.useEffect(() => {
    const handler = window.mapGallery?.watch('activeBasemap', (e) => {
      setBasemap(e);
      setLayers(
        layers.map((l) => {
          l.thumbnailUrl = e.thumbnailUrl;
          return l;
        })
      );
    });
    setBasemap(window.mapGallery?.activeBasemap);

    return () => {
      handler?.remove();
    };
  }, []);

  React.useEffect(() => {
    if (!mapView) return;
    // LayerListVm
    const layerListVM = new LayerListVM({ view: mapView });
    const items = layerListVM.operationalItems.items
      .map((item) => {
        if (item.layer.type === 'group') return item.children.items;
        return item;
      })
      .flat();

    const layers = LayerCollection.map((layer, i) => {
      const { name, label, overlay } = layer;
      // const thumbnailUrl = basemap?.thumbnailUrl;
      // TODO: window.mapGallery.activebasemap.thumbnailUrl is null initially
      const thumbnailUrl =
        window.mapGallery?.items?.items[0]?.basemap?.thumbnailUrl;

        try{
          const lyr = items.find((item) => item.title === name);
          const visible = lyr?.visible;

          if (lyr.error !== null) {
            return null;
          }

          return {
            id: i,
            name,
            label,
            thumbnailUrl,
            thumbnailOverlay: overlay,
            selected: visible,
          };
        }catch(error){
          console.error(error)
          return null
        }

    }).filter(l => l!== null);

    setLayers(layers);
    setLayerList(layerListVM);
    window.mapView = mapView;
    return () => {
      layerListVM.destroy();
    };
  }, []);

  return (
    <div>
      <SidebarHeader>
        <div
          aria-hidden="true"
          className="sidebar-header-icon esri-icon-layers"
        />
        Layers
      </SidebarHeader>

      <SidebarSection>
        <LayerCard
          layers={layerList && getLayers(LayerCollection, layerList)}
          onSelect={toggleLayer}
        />
      </SidebarSection>
    </div>
  );
};
